import { Chip } from "@heroui/react";

import { FetchedTag } from "@/services/api/fetchers/tags";
import clsx from "clsx";
import { getTagBgColorClassName } from "@/features/tags/utils";

interface NoteTagsProps {
  className?: string;
  tags: FetchedTag[];
}

export function NoteTags({ className, tags }: NoteTagsProps) {
  return (
    <div className={clsx("scrollbar-hide flex items-center gap-2 overflow-y-auto", className)} tabIndex={-1}>
      {tags.map((tag) => (
        <Chip
          key={tag.id}
          classNames={{ dot: clsx(getTagBgColorClassName(tag.color)) }}
          variant="dot"
          radius="sm"
          size="sm"
        >
          {tag.name}
        </Chip>
      ))}
    </div>
  );
}
